// css =>
import "../../BaseStructure.css";
import Styled from "./inputsSpace.module.css";

const InputSpace = () => {
    return (
        <div className={`row ${ Styled.InputSpace } `}></div>
    );
};

export default InputSpace;
